/**
 * Created by Stefann on 04/02/2019.
 */

export class EntityChoice {
    constructor(public id: number, public value: string) {}
}
